const doc = [({"se":({"activerecord":({"models":({"invoice":({})}), "attributes":({"invoice":({})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;